import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Checkbox,
  Collapse,
  FormControlLabel,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { EGSwitch } from "../../../../MainComponents/Switch/Switch";

/**
 * Componente reutilizable para mostrar opciones de cierre de denuncias relacionadas
 * Basado en Investigation2/Conclusion/Modals/Conclude.jsx
 */
export const RelatedReportsClosureSection = ({
  relatedReports = [],
  closeLinkedReports,
  setCloseLinkedReports,
  closeAllReports,
  setCloseAllReports,
  selectedReports,
  setSelectedReports,
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();

  const hasRelatedReports = relatedReports && relatedReports.length > 0;

  // Manejar selección individual de reportes
  const handleReportSelection = (reportId) => {
    setSelectedReports((prev) =>
      prev.includes(reportId)
        ? prev.filter((id) => id !== reportId)
        : [...prev, reportId]
    );
  };

  if (!hasRelatedReports) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        p: 2,
        borderRadius: "8px",
        border: `1px solid ${theme.palette.blueGray200?.main || "#e0e0e0"}`,
        backgroundColor: theme.palette.blueGray50?.main || "#f5f5f5",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          fontSize={14}
          fontWeight={600}
          color={theme.palette.secondary?.main || "#000"}
        >
          {t("Conclusion.close_linked_reports") || "Cerrar denuncias vinculadas"}
        </Typography>
        <EGSwitch
          size="small"
          checked={closeLinkedReports}
          onChange={(e) => setCloseLinkedReports(e.target.checked)}
        />
      </Stack>

      <Collapse in={closeLinkedReports}>
        <Box sx={{ mt: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 1 }}
          >
            <Typography
              fontSize={13}
              fontWeight={500}
              color={theme.palette.oxfordBlue?.main || "#000"}
            >
              {t("Conclusion.close_all_reports") || "Cerrar todas las denuncias"}
            </Typography>
            <EGSwitch
              size="small"
              checked={closeAllReports}
              onChange={(e) => setCloseAllReports(e.target.checked)}
            />
          </Stack>

          <Collapse in={!closeAllReports}>
            <Box
              sx={{
                mt: 1,
                p: 1.5,
                borderRadius: "8px",
                backgroundColor: theme.palette.white?.main || "#fff",
                border: `1px solid ${theme.palette.blueGray200?.main || "#e0e0e0"}`,
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <Typography
                fontSize={12}
                fontWeight={600}
                color={theme.palette.blueGray600?.main || "#666"}
                mb={1}
              >
                {t("Conclusion.select_reports_to_close") || "Selecciona las denuncias a cerrar"}
              </Typography>
              <Stack spacing={0.5}>
                {relatedReports.map((report) => (
                  <FormControlLabel
                    key={report.id_report}
                    control={
                      <Checkbox
                        size="small"
                        checked={selectedReports.includes(report.id_report)}
                        onChange={() => handleReportSelection(report.id_report)}
                      />
                    }
                    label={
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography fontSize={13} fontWeight={600} color="primary">
                          {report.folio}
                        </Typography>
                        {/* tracking_code hidden */}
                      </Stack>
                    }
                  />
                ))}
              </Stack>
            </Box>
          </Collapse>
        </Box>
      </Collapse>
    </Box>
  );
};
